import React from "react";

import InputComponent from "../../UI/InputComponent/InputComponent";
import DatePickerComponent from "../../UI/DatePicker/DatepickerComponent";
import DownloadAttachment from "../../UI/DownloadAttachment/DownloadAttachment";

import { Upload, Button, Radio } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const Izvjesce = ({
  values,
  handleInputChange,
  handleDateChange,
  handleSingleFileUpload,
  handleMultiFileUpload,
  handleRadioButton,
  update,
  downloadAttachments,
  removeAttachment,
  handleNumberInput,
}) => {
  return (
    <div>
      <br></br>
      <InputComponent
        onChange={handleInputChange}
        value={values.nazivRevDrustva}
        id="nazivRevDrustva"
        name="nazivRevDrustva"
        controlLabel={
          "Naziv revizorskog društva / Ime i prezime samostalnog revizora"
        }
      />
    <div style={{backgroundColor: 'whitesmoke', padding: 16, marginBottom: 16}}>
      <InputComponent
        onChange={handleNumberInput}
        value={values.registarskiBroj}
        disabled={values.oib}
        name="registarskiBroj"
        id="regBroj"
        controlLabel={"Registarski broj"}
      />
      <InputComponent
        onChange={handleNumberInput}
        value={values.oib}
        disabled={values.registarskiBroj}
        name="oib"
        id="oibDrustva"
        controlLabel={"OIB"}
      />
      {!update ? <p style={{fontStyle: "italic", marginBottom: "0px"}}>Napomena: Nije moguće unijeti oba podatka u isto vrijeme.</p> : null}
    </div>
      <InputComponent
        onChange={handleNumberInput}
        value={values.godina}
        name="godina"
        id="godina"
        controlLabel={"Godina"}
      />
      <DatePickerComponent
        id="datumObjaveIzvjesca"
        handleDayClick={handleDateChange}
        controlLabel={"Datum objave izvješća"}
        index={{ id: "datumObjaveIzvjesca" }}
        width={"100%"}
        value={values.datumObjaveIzvjesca}
      />
      <InputComponent
        onChange={handleInputChange}
        value={values.webStranicaObjaveIzv}
        name="webStranicaObjaveIzv"
        id="webStranicaObjaveIzv"
        controlLabel={"Web stranica objave izvješća"}
      />
      <DatePickerComponent
        id="rokObjave"
        handleDayClick={handleDateChange}
        controlLabel={"Rok objave"}
        index={{ id: "rokObjave" }}
        width={"100%"}
        value={values.rokObjave}
      />
      <label>Ažurirana verzija izvješća</label>
      <div style={{ marginBottom: "16px" }}>
        <Radio.Group
          value={values.azuriranaVerzija}
          onChange={handleRadioButton("azuriranaVerzija")}
        >
          <Radio value={false}>NE</Radio>
          <Radio value={true}>DA</Radio>
        </Radio.Group>
      </div>

      <InputComponent
        onChange={handleInputChange}
        value={values.webStranicaObjaveAzurIzv}
        name="webStranicaObjaveAzurIzv"
        id="webStranicaObjaveAzurIzv"
        controlLabel={"Web stranica objave ažuriranog izvješća"}
      />
      <DatePickerComponent
        id="datObjaveAzurVerIzv"
        handleDayClick={handleDateChange}
        controlLabel={"Datum objave ažurirane verzije izvješća"}
        index={{ id: "datObjaveAzurVerIzv" }}
        width={"100%"}
        value={values.datObjaveAzurVerIzv}
      />
      <DatePickerComponent
        id="datObavNadleznogTijela"
        handleDayClick={handleDateChange}
        controlLabel={"Datum obavještavanja nadležnog tijela"}
        index={{ id: "datObavNadleznogTijela" }}
        width={"100%"}
        value={values.datObavNadleznogTijela}
      />
      <div style={{ padding: 4, width: "100%", backgroundColor: '#f8f9fa' , marginBottom: '16px'}}>
        <p style={{fontWeight: 500, margin: 0, padding: 0}}>Prilozi
        </p>
        <ul>
          <li>dopušteni formati: PDF</li>
          <li>maksimalna veličina datoteke - 10MB</li>
        </ul>
      </div>
      <label>
        Obavijest o iznimci iz članka 13. stavka 2. podstavka 2. Uredbe (EU) br
        537/2014
      </label>
      <>
        <Upload
          multiple
          id={"obavijestOIznimci"}
          beforeUpload={() => {
            return false;
          }}
          accept={"application/pdf"}
          onChange={(file) => handleMultiFileUpload(file, "obavijestOIznimci")}
          fileList={values.obavijestOIznimci}
        >
          <Button className={"upload-btn"} style={{ marginBottom: "16px" }}>
            <UploadOutlined /> Odaberite datoteku
          </Button>
        </Upload>
        <DatePickerComponent
          id="datObavijestiOIznimci"
          handleDayClick={handleDateChange}
          controlLabel={"Datum obavijesti o iznimci"}
          index={{ id: "datObavijestiOIznimci" }}
          width={"100%"}
          value={values.datObavijestiOIznimci}
        />
        <label>Dokumenti</label>
        <Upload
          multiple
          id={"dokumenti"}
          beforeUpload={() => {
            return false;
          }}
          accept={"application/pdf"}
          onChange={(file) => handleMultiFileUpload(file, "dokumenti")}
          fileList={values.dokumenti}
        >
          <Button className={"upload-btn"} style={{ marginBottom: "16px" }}>
            <UploadOutlined /> Odaberite datoteku
          </Button>
        </Upload>
        <InputComponent
          onChange={handleInputChange}
          value={values.napomena}
          name="napomena"
          id="napomena"
          controlLabel={"Napomena"}
        />
        {update &&
          (values.obavijestOIznimciOld.length > 0 ||
            values.dokumentiOld.length > 0) && (
            <>
              <br></br>
              <span>
                <b>Prilozi učitani na unosu evidencije:</b>
              </span>
              <br></br>
              {values.obavijestOIznimciOld.length > 0 && (
                <label>
                  Obavijest o iznimci iz članka 13. stavka 2. podstavka 2.
                  Uredbe (EU) br. 537/2014
                </label>
              )}

              {values.obavijestOIznimciOld.length > 0 &&
                values.obavijestOIznimciOld.map((element) => {
                  return (
                    <DownloadAttachment
                      id={element.idPredPolja}
                      downloadAttachments={downloadAttachments}
                      removeAttachment={removeAttachment}
                      contentType={element.contentType}
                      fileName={element.fileName}
                      group={"obavijestOIznimciOld"}
                    />
                  );
                })}

              {values.dokumentiOld.length > 0 && <label>Dokumenti</label>}

              {values.dokumentiOld.length > 0 &&
                values.dokumentiOld.map((element) => {
                  return (
                    <DownloadAttachment
                      id={element.idPredPolja}
                      downloadAttachments={downloadAttachments}
                      removeAttachment={removeAttachment}
                      contentType={element.contentType}
                      fileName={element.fileName}
                      group={"dokumentiOld"}
                    />
                  );
                })}
            </>
          )}
      </>
    </div>
  );
};

export default Izvjesce;
